module.exports = __webpack_public_path__ + "static/media/social.4cf87446.jpg";